import { Button } from "react-bootstrap";

export default function ButtonComp({
  buttonType = "submit",
  isSubmitting = false,
  buttonText = "Submit"
}) {
  return (
    <Button
      className="btn btn-primary me-1 mb-1 d-flex align-items-center justify-content-center"
      type={buttonType}
      disabled={isSubmitting}
      style={{
        cursor: isSubmitting ? "not-allowed" : "pointer",
        position: "relative"
      }}>
      {isSubmitting && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
          style={{
            pointerEvents: "none",
            position: "relative"
          }}></span>
      )}
      {buttonText}
    </Button>
  );
}
